/// <reference path='../_all.ts' />

module search {
  'use strict';

  export class Results {
    constructor(
      public query   : string,
      public topResult: any[],
      public industries : Result<Industry>,
      public tasks: Result<MeasuringTask>,
      public allProducts: Result<Product>,
      public products : Result<Product>,
      public productArchive : Result<Product>,
      public parts: Result<Part>,
      public documents: Result<Document>,
      public pictures: Result<Document>,
      public allResults: AllSearchResult
    ) { }
  }

  export class AllSearchResult {
    constructor(
      public Items   : any,
      public MetaData : MetaData,
      public TotalResults : number
    ) {}

  }
    export class MetaData {
    constructor(
        public Id: string,
        public Type: string,
        public Score: number,
        public UrlD: string,
        public UrlE: string
    ) {}

  }

  export class Result<T> {
    constructor(
      public Hits: ResultHit<T>[],
      public Count: number
    ) { }
  }
  export class ResultHit<T> {
    constructor(
      public Item: T,
      public Highlights: object[],
      //public Highlights: { Key: string, Value: string[] }[],
      //public Highlights: { Field: string, Highlights: string []}[],
      public Score: number,
      public Index: string
    ) { }
  }

  export class ApplicationsSearchServiceData {
    constructor(
      public query   : string,
      public topResult : any[],
      public industries : Result<Industry>,
      public tasks : Result<MeasuringTask>,
      public products : Result<Product>
    ) { }
  }    

  export class Industry {
    constructor(
      public Id   : number,
      public Name : string,
      public Order   : number,
      public Url : string,
      public Icon : string
    ) { }
  }  
      

  export class MeasuringTask {
    constructor(
      public Id   : number,
      public Name : string,
      public RefCount   : number,
      public Url : string
    ) { }
  }  

  export class Product {
    constructor(
      public CategoryId   : number,
      public CategoryNameD : string,
      public CategoryNameE   : string,
      public Id : number,
      public Name : string,
      public TextD : string,
      public TextE : string,
      public LaunchDate : Date,
      public KillingDate : Date,
      public ImagePath : string,
      public UrlD : string,
      public UrlE : string
    ) { }
  }  



  export class PartSearchServiceData {
    constructor(
      public Query   : string,
      public Hits: ResultHit<Part>[],
      public Count: number
    ) { }
  }  


  export class Part {
    constructor(
      public Id   : string,
      public Text : string,
      public IsBlocked   : boolean,
      public ReplaceCount : number,
      public ReplaceById : string
    ) { }
  }  



  export class DocumentSearchServiceData {
    constructor(
      public Query   : string,
      public Hits: ResultHit<Document>[],
      public Count: number
    ) { }
  }  

  export class Document {
    constructor(
      public DocumentID   : string,
      public DocumentTypeName : string,
      public DocumentFileSrcName : string,
      public RevDestSize : number,
      public DocumentTitle : string,
      public DocumentFileSrcRevId : number
    ) { }
  }  

  
  export class ProductArchiveSearchServiceData {
    constructor(
      public Query   : string,
      public Hits: ResultHit<Product>[],
      public Count: number
    ) { }
  }    


}




